import { HttpErrorResponse } from '@angular/common/http';

/**
 * Códigos de licença do backend (`Errors.License`, em Evolve/Core/Domain/Errors/Error.License.cs).
 *
 * A leitura é pelo CÓDIGO e nunca pelo status: 403 também é o status de falta de permissão de
 * verdade, e foi justamente a confusão entre as duas coisas que a AE-711 veio desfazer. Renomear
 * um destes valores exige mudar o backend junto.
 */
export const LICENSE_PACKAGE_MISSING = 'License.PackageMissing';
export const LICENSE_FEATURE_MISSING = 'License.FeatureMissing';

/**
 * `package` — usuário sem o pacote raiz: não tem acesso a nada, vai para a tela de licença.
 * `feature` — usuário dentro do produto, sem a licença de UMA funcionalidade: recebe um toast e
 * continua onde está.
 */
export type LicenseErrorKind = 'package' | 'feature';

/** Rota da tela de licença ausente. */
export const LICENSE_REQUIRED_ROUTE = '/license-required';

interface ProblemDetailsErrorEntry {
  code?: string;
}

interface ProblemDetailsBody {
  errors?: ProblemDetailsErrorEntry[];
}

/**
 * Classifica um erro HTTP como falta de licença, quando for o caso.
 *
 * O corpo é o mesmo ProblemDetails dos dois caminhos do backend — o do pipeline do MediatR
 * (`ErrorOrExtensions`) e o da autenticação (`CustomAuthenticationHandler`) —, por isso um leitor
 * só serve para ambos.
 */
export function readLicenseError(err: unknown): LicenseErrorKind | null {
  if (!(err instanceof HttpErrorResponse) || err.status !== 403) {
    return null;
  }

  // O corpo pode não ser JSON (proxy no caminho, resposta vazia, responseType text). Nesse caso
  // não há código para ler, e o erro segue como 403 comum.
  const body = err.error as ProblemDetailsBody | null;
  if (!body || typeof body !== 'object' || !Array.isArray(body.errors)) {
    return null;
  }

  const codes = body.errors.map((e) => e?.code);

  if (codes.includes(LICENSE_PACKAGE_MISSING)) {
    return 'package';
  }

  if (codes.includes(LICENSE_FEATURE_MISSING)) {
    return 'feature';
  }

  return null;
}
